export enum RfqInterpretation {
  FULL = 'full',
  SPLIT = 'split',
  NOTIFY_MM = 'notifyMm',
  NONE = 'none',
}
